module.exports = __webpack_public_path__ + "assets/img/GlossaryBAPC.3d31a21f.png";